(() => {
  'use strict';
  const node = document.getElementById('pt-launch-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  if (config.enabled !== true) return;
  const variants = new Set(config.variants);
  const handles = new Set(config.handles);
  const skus = new Set(config.skus);
  const items = new Map((config.items || []).map(item => [item.handle, item]));
  function canPurchase(button) {
    const form = button.closest('form');
    const id = form?.querySelector('[name="id"]')?.value || button.dataset.variantId || button.dataset.variant;
    if (!id || !variants.has(String(id))) return false;
    const policyNode = form?.querySelector('[data-pt-card-purchase-policy]') || document.querySelector('[data-pt-launch-variant-policy]');
    if (!policyNode) return false;
    try {
      const policy = JSON.parse(policyNode.textContent);
      return policy.purchaseAllowed === true && policy.variants.some(item => String(item.id) === String(id) && item.eligible === true);
    } catch { return false; }
  }
  const cardSelector = 'product-card,.pt-shopping__card,.pt-ht-card,.pt-ps-showcase__card,.pt-master__card,.ptm__card,.pt-static-rec,.pt-qa__card,.ptbr__card,[data-pt-qa-item]';
  function filter(root) {
    const nodes = root === document ? [document] : root instanceof Element ? [root] : [];
    for (const scope of nodes) {
      const cards = [...scope.querySelectorAll(cardSelector)];
      if (scope.matches?.(cardSelector)) cards.unshift(scope);
      for (const card of cards) {
        const link = card.matches('a') ? card : card.querySelector('a[href*="/products/"]');
        let handle = card.dataset.productHandle;
        let variant = card.dataset.variantId || card.querySelector('[data-variant]')?.dataset.variant || card.querySelector('[data-pt-quickadd]')?.dataset.ptQuickadd;
        if (link) {
          try {
            const url = new URL(link.getAttribute('href'), location.origin);
            if (url.pathname.includes('/products/')) handle = url.pathname.split('/products/')[1]?.split('/')[0];
            variant ||= url.searchParams.get('variant');
            if (!variant && /^#pt-kit-details-\d+$/.test(url.hash)) variant = url.hash.replace('#pt-kit-details-','');
          } catch { continue; }
        }
        if ((handle && !handles.has(handle)) || (variant && !variants.has(String(variant))) || (card.dataset.sku && !skus.has(card.dataset.sku))) {
          card.remove();
          continue;
        }
        if (handle && handles.has(handle) && link && link.getAttribute('href')?.includes('/products/')) {
          const item = items.get(handle);
          if (config.previewOnly !== false && config.designMode === true && item?.status === 'DRAFT' && card.dataset.ptPublished !== 'true') {
            const id = variant && variants.has(String(variant)) ? variant : item.variantId;
            const url = new URL('/collections/all', location.origin);
            url.searchParams.set('preview_theme_id',String(config.themeId));
            url.hash = 'pt-kit-details-' + id;
            if (link.getAttribute('href') !== url.pathname + url.search + url.hash) link.setAttribute('href',url.pathname + url.search + url.hash);
          }
        }
      }
      scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"],button[data-pt-static-add],button[data-pt-quickadd]').forEach(button => { const allowed = canPurchase(button); button.disabled = !allowed; button.setAttribute('aria-disabled',String(!allowed)); });
    }
  }
  const init = () => {
    const recovery = document.getElementById('pt-launch-category-recovery');
    const category = location.pathname.split('/collections/')[1]?.split('/')[0];
    if (recovery instanceof HTMLTemplateElement && config.categories?.[category]) {
      const fragment = recovery.content.cloneNode(true);
      fragment.querySelectorAll('[data-pt-fallback-title],.pt-shopping h2').forEach(title => { title.textContent = config.categories[category]; });
      fragment.querySelectorAll('[data-pt-shopping-qa]').forEach(grid => { grid.dataset.collection = category; });
      fragment.querySelectorAll('script').forEach(script => script.remove());
      recovery.before(fragment);
      document.querySelector('[data-pt-recovery-content]')?.remove();
    }
    const excludedCategories = new Set(['frontpage','all-purpose-cleaners-degreasers','new-arrivals','best-sellers']);
    document.querySelectorAll('a[href*="/collections/"]').forEach(link => {
      try { const url = new URL(link.href,location.origin); const category = url.pathname.split('/collections/')[1]?.split('/')[0]; if (excludedCategories.has(category)) link.remove(); } catch {}
    });
    filter(document);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'childList') record.addedNodes.forEach(filter);
        else filter(record.target);
      }
    });
    observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['data-product-handle','data-variant','href']});
  };
  document.addEventListener('submit',event => {
    if (event.target instanceof HTMLFormElement && /\/cart\/add/.test(event.target.action)) { const button = event.target.querySelector('button[type="submit"]'); if (!button || !canPurchase(button)) event.preventDefault(); }
  },true);
  document.addEventListener('pt:previews-ready',() => window.dispatchEvent(new HashChangeEvent('hashchange')));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',event => filter(event.target));
})();

